import styled from 'styled-components';

const Color = styled.div`
  width: 26px;
  height: 26px;
  border-radius: 100%;
  background: ${({ color }) => color};
`;

export default Color;
